export default __webpack_public_path__ + "static/media/cursing.632c0a24.png";